// extracted by mini-css-extract-plugin
export default {"registerContainer":"RegisterScreen_registerContainer__FMiU+","formErrorError":"RegisterScreen_formErrorError__K2CoT","register":"RegisterScreen_register__z5xX4"};